module.exports = __webpack_public_path__ + "static/img/goods-50.3c89777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-50.png
// module id = Yk3n
// module chunks = 2